// Centralized lazy-import prefetchers. Mirror the imports in route files
// so calling these triggers the SAME chunk to be downloaded — turning
// hover/touch into navigation-ready chunks.
//
// IMPORTANT: keep these in sync with routes/*.tsx imports.

export const prefetchCategoryPage = () => import("@/pages/CategoryPage");
export const prefetchDynamicCategoryPage = () => import("@/pages/DynamicCategoryPage");
export const prefetchProductPage = () => import("@/pages/ShopifyProductDetailPage");
export const prefetchBrandsPage = () => import("@/pages/BrandsPage");
export const prefetchBrandDetailPage = () => import("@/pages/BrandDetailPage");
export const prefetchCart = () => import("@/pages/CartPage");
export const prefetchAccount = () => import("@/pages/MyAccountPage");
export const prefetchAuth = () => import("@/pages/AuthPage");
export const prefetchOutlet = () => import("@/pages/OutletPage");
export const prefetchBlog = () => import("@/pages/BlogPage");

/**
 * Returns the right prefetcher for a given internal href.
 * Used by <PrefetchLink> when the caller doesn't pass an explicit prefetch fn.
 */
export const prefetchForHref = (href: string): (() => Promise<unknown>) | undefined => {
  if (!href || href.startsWith("http") || href.startsWith("#")) return;
  if (href === "/varumärken" || href === "/varumarken/") return prefetchBrandsPage;
  if (href.startsWith("/varumarken/")) return prefetchBrandDetailPage;
  if (href === "/cart" || href === "/varukorg") return prefetchCart;
  if (href === "/mitt-konto" || href.startsWith("/mitt-konto/")) return prefetchAccount;
  if (href === "/auth" || href.startsWith("/auth/")) return prefetchAuth;
  if (href === "/outlet") return prefetchOutlet;
  if (href === "/artiklar" || href.startsWith("/blogg/")) return prefetchBlog;
  if (href.startsWith("/produkt/")) return prefetchProductPage;
  // Category routes: /:l1/:l2/:l3, /:cat, /:cat/:sub
  const segs = href.split("?")[0].split("#")[0].split("/").filter(Boolean);
  if (segs.length === 3) return prefetchDynamicCategoryPage;
  if (segs.length === 1 || segs.length === 2) return prefetchCategoryPage;
  return undefined;
};
